import { FC } from 'react';
import useHeader from '../../hooks/useHeader';
import AutoLogoffModal from './AutoLogoffModal';
import ElmerModalAlert from './ElmerModalAlert';
import styles from './Header.module.scss';
import PageLoadingLayer from './PageLoadingLayer';
import SerialInfoModal from './SerialInfoModal';
import { PAGE_PATH_NAME } from '../../utils/const';

const Header: FC = () => {
  const useHeaderValue = useHeader();

  return (
    <>
      {useHeaderValue.isCallingApi && <PageLoadingLayer />}
      {useHeaderValue.headerAlert.type !== null &&
        (useHeaderValue.headerAlert.type === 'INFO_LOGOFF' ? (
          <AutoLogoffModal
            isModalOpen={useHeaderValue.headerAlert.type !== null}
            closeModal={useHeaderValue.headerAlert.onClickCloseModal}
          />
        ) : (
          <ElmerModalAlert
            isModalOpen={useHeaderValue.headerAlert.type !== null}
            alertTitle={useHeaderValue.headerAlert.alertTitle}
            alertText={useHeaderValue.headerAlert.alertText}
            alertButtons={useHeaderValue.headerAlert.alertButtons}
          />
        ))}

      <SerialInfoModal
        isOpen={useHeaderValue.serialInfoDialog.isOpen}
        serialNumber={useHeaderValue.serialInfoDialog.serialNumber}
        courseName={useHeaderValue.serialInfoDialog.courseName}
        onClickCloseButton={useHeaderValue.serialInfoDialog.onClickClose}
        onClickCopy={useHeaderValue.serialInfoDialog.onClickCopy}
      />
      <header
        className={`${styles['app-header']} ${
          useHeaderValue.pathName === PAGE_PATH_NAME.SERIAL_INPUT
            ? styles['is-hidden']
            : ''
        } ${
          useHeaderValue.pathName === PAGE_PATH_NAME.TRAINING
            ? styles['is-position-relative']
            : ''
        }`}
      >
        <div className={styles['app-header-left']}>
          {useHeaderValue.isAppearBackButton && (
            <button
              type="button"
              onClick={useHeaderValue.onClickBackButton}
              className={styles['app-header-btn']}
            >
              <figure>
                <div className={`${styles['svg-icon']} ${styles['ic-home']}`} />
              </figure>
            </button>
          )}
        </div>
        <div className={styles['app-header-center']}>
          <div className={styles['header-logo-outer']}>
            <figure>
              <div className={styles['product-logo']} />
            </figure>
          </div>
        </div>

        <div className={styles['app-header-right']}>
          {useHeaderValue.accessKey && (
            <div className={styles['app-header-btn-container']}>
              <button
                type="button"
                onClick={useHeaderValue.onClickMenuButton}
                className={styles['app-header-btn']}
                ref={useHeaderValue.openHeaderMenuButtonRef}
              >
                <figure>
                  <div
                    className={`${styles['svg-icon']} ${styles['ic-more-vert']}`}
                  />
                </figure>
              </button>

              <div
                className={styles['app-header-btn-menu']}
                hidden={!useHeaderValue.isOpenMenu}
                ref={useHeaderValue.headerMenuRef}
              >
                <ul className={styles['menu-list-outer']}>
                  <li className={styles['menu-list-item']}>
                    <button
                      type="button"
                      onClick={useHeaderValue.menuOnClick.onClickHelp}
                      className={styles['menu-list-item-inner-btn']}
                    >
                      <p>ヘルプ</p>
                      <figure>
                        <div
                          className={`${styles['svg-icon']} ${styles['ic-open-in-new']} ${styles['mod-colorSecondary']}`}
                        />
                      </figure>
                    </button>
                  </li>
                  {useHeaderValue.pathName === PAGE_PATH_NAME.LESSON && (
                    <li>
                      <button
                        type="button"
                        onClick={
                          useHeaderValue.menuOnClick.onClickResetLearningHistory
                        }
                        className={styles['menu-list-item-inner-btn']}
                      >
                        <p>学習進捗リセット</p>
                      </button>
                    </li>
                  )}
                  <li>
                    <button
                      type="button"
                      onClick={useHeaderValue.menuOnClick.onClickLogOff}
                      className={styles['menu-list-item-inner-btn']}
                    >
                      <p>利用登録解除</p>
                    </button>
                  </li>
                  {useHeaderValue.pathName !== PAGE_PATH_NAME.TRAINING && (
                    <li className={styles['menu-list-item']}>
                      <button
                        type="button"
                        onClick={useHeaderValue.menuOnClick.onClickSerialInfo}
                        className={styles['menu-list-item-inner-btn']}
                      >
                        <p>シリアル確認</p>
                      </button>
                    </li>
                  )}
                  <li>
                    <button
                      type="button"
                      onClick={useHeaderValue.menuOnClick.onClickAttention}
                      className={styles['menu-list-item-inner-btn']}
                    >
                      <p>ご注意</p>
                      <figure>
                        <div
                          className={`${styles['svg-icon']} ${styles['ic-open-in-new']} ${styles['mod-colorSecondary']}`}
                        />
                      </figure>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
